export default __webpack_public_path__ + "static/media/070_boost.first.dfa1d8b7.png";